import { SxProp, useSx } from 'dripsy';
import { StyleProp, ViewStyle } from 'react-native';

interface ISxPropParams {
  styleProp?: StyleProp<ViewStyle>;
  sxProp?: SxProp;
}

export function useSxProp({
  styleProp,
  sxProp,
}: ISxPropParams): StyleProp<ViewStyle> {
  const sx = useSx();

  const sxStyle = sxProp && sx(sxProp);

  return styleProp && sxStyle
    ? [styleProp, sxStyle]
    : sxStyle || styleProp;
}
